import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook } from '../mui-icons';
import { useTranslation } from '../hooks/useTranslation';
import iconImage from '../assets/icon.webp';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer" role="contentinfo" aria-label="Rodapé do site">
      <div className="container footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <img 
              src={iconImage} 
              alt="PersonalNutri - Nutrição Inteligente com IA" 
              className="footer-icon"
              width={60}
              height={60}
              loading="lazy"
              decoding="async"
            />
            <p className="footer-text">
              {t('footer.tagline')}
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">{t('footer.quickLinks')}</h4>
            <div className="footer-links">
              <Link to="/" className="footer-link">{t('footer.links.home')}</Link>
              <Link to="/about" className="footer-link">{t('footer.links.about')}</Link>
              <Link to="/plans" className="footer-link">{t('header.plans')}</Link>
              <Link to="/download" className="footer-link">Download</Link>
              <Link to="/support" className="footer-link">{t('footer.links.support')}</Link>
              <Link to="/partnerships" className="footer-link">{t('footer.links.partnerships')}</Link>
              <Link to="/privacy" className="footer-link">{t('footer.links.policy')}</Link>
              <Link to="/terms" className="footer-link">{t('footer.links.terms') || 'Termos de Uso'}</Link>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">{t('footer.contact')}</h4>
            <p className="footer-text">contato@personalnutri.app</p>
            <p className="footer-text">{t('footer.schedule')}</p>
            
            {/* Redes Sociais */}
            <div className="footer-social">
              <h4 className="footer-subtitle">{t('footer.followUs') || 'Siga-nos'}</h4>
              <div className="social-links">
                <a 
                  href="https://www.instagram.com/personalnutri.app/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link instagram"
                  aria-label="Siga-nos no Instagram"
                >
                  <Instagram sx={{ fontSize: 24 }} />
                  <span>Instagram</span>
                </a>
                <a 
                  href="https://www.facebook.com/personalnutriapp" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link facebook"
                  aria-label="Siga-nos no Facebook"
                >
                  <Facebook sx={{ fontSize: 24 }} />
                  <span>Facebook</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            {t('footer.copyright').replace('{year}', new Date().getFullYear())}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

